import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { ThumbsDownIcon, ThumbsUpIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ExternalIcon = () => null;
const CompanionFooter = ({
  additionalButtons
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    borderBlockStartColor: "border-core-subtle",
    borderBlockStartStyle: "solid",
    borderBlockStartWidth: "100",
    justifyContent: "space-between",
    paddingBlock: "400",
    paddingInline: "700",
    children: [/*#__PURE__*/_jsxs(ButtonWrapper, {
      horizontalGap: 16,
      children: [/*#__PURE__*/_jsx(IconButton, {
        use: "unstyled",
        children: /*#__PURE__*/_jsx(ThumbsUpIcon, {})
      }), /*#__PURE__*/_jsx(IconButton, {
        use: "unstyled",
        children: /*#__PURE__*/_jsx(ThumbsDownIcon, {})
      })]
    }), /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.interactiveEducation.disclaimer",
      options: {
        link: /*#__PURE__*/_jsx(HelpIcon, {
          title: "",
          children: /*#__PURE__*/_jsx(Link, {
            ExternalIcon: ExternalIcon,
            external: true,
            href: "https://legal.hubspot.com/hubspot-beta-terms",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.interactiveEducation.seeTerms"
            })
          })
        })
      }
    }), additionalButtons]
  });
};
export default CompanionFooter;